import { render, staticRenderFns } from "./ModalSigtap.vue?vue&type=template&id=1880622e&scoped=true"
import script from "./ModalSigtap.vue?vue&type=script&lang=js"
export * from "./ModalSigtap.vue?vue&type=script&lang=js"
import style0 from "./ModalSigtap.vue?vue&type=style&index=0&id=1880622e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880622e",
  null
  
)

export default component.exports